import { FONT_FAMILY, PRIMARY, SLATE, SEMANTIC } from 'helpers/theme';

// ── ECharts building blocks (Phase 5) ────────────────────────────────────────
// One palette + one set of axis/grid/tooltip fragments for every dashboard
// chart, derived from the design tokens. Spread the fragments into options:
//
//   option = {
//     color: CHART_PALETTE,
//     grid: { ...CHART_GRID },
//     xAxis: { type: 'category', ...CHART_CATEGORY_AXIS },
//     yAxis: { type: 'value', ...CHART_VALUE_AXIS },
//     tooltip: { ...CHART_TOOLTIP },
//   }

// Categorical series palette — primary first, then distinct hues tuned to sit
// together (green/amber/violet/sky/rose/teal/slate).
export const CHART_PALETTE = [
  PRIMARY[600],
  '#10b981', // emerald-500
  '#f59e0b', // amber-500
  '#8b5cf6', // violet-500
  '#0ea5e9', // sky-500
  '#f43f5e', // rose-500
  '#14b8a6', // teal-500
  SLATE[400]
];

export const CHART_FONT = {
  fontFamily: FONT_FAMILY,
  color: SLATE[600]
};

export const CHART_GRID = {
  left: 8,
  right: 16,
  top: 32,
  bottom: 8,
  containLabel: true
};

export const CHART_CATEGORY_AXIS = {
  axisLine: { lineStyle: { color: SLATE[200] } },
  axisTick: { show: false },
  axisLabel: { ...CHART_FONT, fontSize: 11 }
};

export const CHART_VALUE_AXIS = {
  axisLine: { show: false },
  axisTick: { show: false },
  splitLine: { lineStyle: { color: SLATE[100] } },
  axisLabel: { ...CHART_FONT, fontSize: 11 }
};

export const CHART_TOOLTIP = {
  backgroundColor: '#ffffff',
  borderColor: SLATE[200],
  textStyle: { ...CHART_FONT, color: SLATE[800], fontSize: 12 },
  extraCssText: 'box-shadow: 0 8px 20px rgba(2,6,23,0.10); border-radius: 8px;'
};

export const CHART_LEGEND = {
  icon: 'circle',
  itemWidth: 8,
  itemHeight: 8,
  textStyle: { ...CHART_FONT, fontSize: 11 }
};

// Semantic colors for status series (won/lost, approved/rejected...).
export const CHART_SEMANTIC = SEMANTIC;
